export const blockListTitles = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Block name", colWidth: "150px", key: "name" },
  { titleName: "Branch name", colWidth: "150px", key: "branchName" },
];
